<template>
  <v-dialog
    v-model="isActive"
    :max-width="maxWidth"
    heigth="100vh"
    persistent
  >
    <form @submit.prevent.stop="onSubmit">
      <v-card>
        <v-progress-linear
          v-if="isLoading"
          color="info"
          indeterminate
          absolute
        />

        <v-toolbar dense class="elevation-0">
          <slot name="header" />

          <v-spacer />

          <v-btn v-if="!closeless" icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-title class="headline pt-0 BModalConfirm__title">
          <slot name="title-text">
            <span v-html="titleText" />
          </slot>
        </v-card-title>

        <v-card-text>
          <template v-if="isSuccess">
            <span v-html="successText" />
          </template>

          <slot v-else>
            {{ mainText }}
          </slot>

          <template v-if="isError">
            <slot name="error" :messages="errorMessages">
              <div
                v-if="errorMessages"
                class="error--text"
                v-text="errorMessages"
              />
              <div
                v-else
                class="error--text"
                v-html="errorText"
              />
            </slot>
          </template>
        </v-card-text>

        <v-card-actions v-if="isSuccess">
          <slot name="footer" :loading="isLoading" :close="close">
            <v-spacer />

            <v-btn
              depressed
              type="button"
              @click="close()"
              v-text="closeBtn"
            />
          </slot>
        </v-card-actions>

        <v-card-actions v-else class="BModalConfirm__actions">
          <slot name="footer" :loading="isLoading" :close="close">
            <slot
              name="footer-before"
              :loading="isLoading"
              :close="close"
            />

            <v-spacer />

            <v-btn
              v-if="!canceless"
              text
              type="button"
              @click="close()"
              v-text="cancelBtn"
            />

            <v-btn
              v-if="!successless"
              depressed
              :disabled="isLoading"
              type="submit"
              v-text="successBtn"
            />

            <slot
              name="footer-after"
              :loading="isLoading"
              :close="close"
            />
          </slot>
        </v-card-actions>
      </v-card>
    </form>
  </v-dialog>
</template>

<script>
import { getErrorMessages } from '@/helpers/getErrorMessages'


export default {
  name: 'BModalConfirm',
  $_veeValidate: {
    validator: 'new',
  },
  inheritAttrs: false,
  props: {
    titleText: {
      type: String,
      // default: 'Подтверждение',
    },
    mainText: {
      type: String,
      default: 'Вы уверены?',
    },
    successText: {
      type: String,
      default: 'Успешно',
    },
    errorText: {
      type: String,
      default: 'Ошибка',
    },
    cancelBtn: {
      type: String,
      default: 'Отменить',
    },
    canceless: Boolean,
    successless: Boolean,
    successBtn: {
      type: String,
      default: 'Подтвердить',
    },
    closeless: Boolean,
    closeBtn: {
      type: String,
      default: 'Закрыть',
    },
    action: {
      type: Function,
      // required: true,
    },
    cancelAction: Function,
    maxWidth: {
      type: String,
      default: '480px',
    },
    disableSuccessNotification: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: false,
      isLoading: false,
      isSuccess: this.success,
      isError: false,
      errorMessages: '',
    }
  },
  destroyed() {
    if (this.resolve) {
      this.resolve(this.isSuccess)
      this.resolve = null
    }
  },
  methods: {
    async onSubmit() {
      this.isError = false
      this.errorMessages = false

      const result = await this.$validator.validate()
      if (!result) return

      if (!this.action) {
        this.$emit('submit')
        // ждем пока кто-то внешний съреагирует на событие,
        // а потом сами закроем, если еще не закроется.
        await this.$nextTick()
        await this.close(true)
        return
      }

      this.onAction()
    },
    open() {
      this.isActive = true

      return new Promise((resolve) => {
        this.resolve = resolve
      })
    },
    async close(flag = this.isSuccess) {
      this.isActive = false
      this.$emit('closed')

      if (this.cancelAction && !flag) {
        await this.cancelAction()
      }

      if (this.resolve) {
        this.resolve(flag)
        this.resolve = null
      }
    },
    async onAction() {
      this.isLoading = true

      try {
        await this.action()
        this.onSuccess()
      } catch (e) {
        this.onError(e)
        // eslint-disable-next-line no-console
        console.warn(e)
      }

      this.isLoading = false
    },
    onSuccess() {
      if (!this.disableSuccessNotification) {
        this.$notice.create(this.successText)
      }
      this.isSuccess = true

      /*
      // eslint-disable-next-line no-underscore-dangle
      if (this.$parent._isDestroyed) {
        this.$notice.create(this.successText)
      } else {
        this.isSuccess = true
      }
      */
    },
    onError(e) {
      // eslint-disable-next-line no-underscore-dangle
      if (this.$parent._isDestroyed) {
        const options = { message: this.errorText }
        this.$notice.errors(e, options)
      } else {
        this.isError = true
        this.errorMessages = getErrorMessages(e).join(', ')
      }
    },
  },
}
</script>

<style lang="scss">
.BModalConfirm {
  &__actions {
    position: sticky;
    bottom: 0;
    z-index: 2;
    background-color: $color-white;
  }

  &__title {
    word-break: break-word;
  }
}
</style>
